<template>
  <Listbox class="text-sm bg-white" :disabled="disabled || (slotOptions.length == 0 && options.length == 0)"
    :modelValue="modelValue" @update:modelValue="updateModelValue" v-slot="{ open }">
    <div class="h-max relative">
      <ListboxButton
        class="rounded-md w-full h-full py-1.5 px-2.5 relative border text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500"
        :style="disabled || (slotOptions.length == 0 && options.length == 0)
          ? { background: 'rgb(249, 250, 255)' }
          : { background: 'white' }
          ">
        <template v-if="slotOptions.length > 0">
          <component :is="curSlot" />
        </template>
        <span v-else-if="options.length > 0">
          {{
            options && typeof options[0] == "object"
              ? options.find((item) => item.value == modelValue)?.label ||
              placeholder
              : modelValue || placeholder
          }}
        </span>
        <span v-else>无可选选项</span>
        <img class="w-3 absolute inset-y-0 right-2.5 my-auto transition-transform duration-300"
          :class="{ 'rotate-180': open }" src="@icons/select.png" />
      </ListboxButton>
      <ListboxOptions class="absolute w-full border-x-2 border-b-2 overflow-y-auto max-h-80 z-10 py-[10px] bg-white">
        <template v-if="slotOptions.length > 0">
          <ListboxOption class="h-8 flex items-center bg-white hover:bg-[#F3F4F9]" :class="(item.disabled != 1 ? ' cursor-pointer' : '') +
            (item.disabled && item.disabled != 0 ? ' bg-[#F3F4F9]' : '')
            " v-for="(item, index) in slotOptions" :key="item.render().props?.value"
            :value="item.render().props?.value" @click="selectChange(index)">
            <component :is="item" />
          </ListboxOption>
        </template>
        <template v-else-if="options.length > 0">
          <ListboxOption class="h-8 px-2.5 py-1 flex items-center bg-white hover:bg-[#F3F4F9]" :class="(item.disabled != 1 ? ' cursor-pointer' : '') +
            (item.disabled && item.disabled != 0 ? ' bg-[#F3F4F9]' : '')
            " v-for="(item, index) in options" :key="item.value" :value="item.value" :disabled="item.disabled == 1"
            @click="selectChange(index)">
            <span class="flex-1" :style="{ color: modelValue === item.value ? '#47496F' : 'inherit' }">
              {{ item.label || item }}
            </span>
            <svg v-if="modelValue === item.value" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-[#47496F] ml-2"
              viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd" />
            </svg>
          </ListboxOption>
        </template>
      </ListboxOptions>
    </div>
  </Listbox>
</template>

<script setup>
import {
  computed,
  reactive,
  useSlots,
  watch,
  markRaw,
  shallowReactive,
} from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
const props = defineProps({
  modelValue: { type: [Number, String] },
  options: { type: Array, default: [] },
  placeholder: String,
  disabled: { type: Boolean, default: false },
});
// console.log("☆★☆★☆★",props)

const slotOptions = shallowReactive([]);
// 针对颜色得选项通过sorts改变样式
const slots = useSlots();
if (slots.default) {
  watch(
    slots.default,
    () => {
      if (slots.default) {
        slotOptions.splice(0);
        slots.default().forEach((item) => {
          const symbolType = item.type.toString();
          if (symbolType == "Symbol(Fragment)" || symbolType == "Symbol()") {
            item.children.forEach((item) => {
              slotOptions.push({
                render: () => {
                  return item;
                },
              });
            });
          } else {
            slotOptions.push({
              render: () => {
                return item;
              },
            });
          }
        });
      }
    },
    { immediate: true }
  );
}
const curSlot = computed(() => {
  return slotOptions.find(
    (item) => item.render().props?.value == props.modelValue
  );
});

const emits = defineEmits(["update:modelValue", "selectChange"]);
function updateModelValue(value) {
  // console.log("update:modelValue")
  emits("update:modelValue", value);
}
function selectChange(index) {
  // console.log(index,props,9909)
  const option = props.options[index];
  //   console.log("selectChange")
  emits("selectChange", { option: option, index: index });
}
</script>

<style lang="scss" scoped></style>
